module.exports = __webpack_public_path__ + "img/inst-9.db6ff964.png";